import React, { useMemo } from 'react';
import { useStoreState } from 'state/hooks/store.state.hook';
import { EBundlesInternalViewModel } from 'utils/enums';
import { ProductMadnessValueBlock } from 'components/StoreCustomSection/ProductMadnessValueBlock';

const jackpotSlotsBackgroundImage =
  'https://media.appcharge.com/media/shop-images/JMS-banner.png';
const jackpotSlotsDesktopLogo =
  'https://media.appcharge.com/media/shop-images/PJS--welcome-logo-desktop.png';
const bigFishBackgroundImage =
  'https://media.appcharge.com/media/shop-images/BFC-banner.png';
const bigFishDesktopLogo =
  'https://media.appcharge.com/media/shop-images/BFC--welcome-logo-desktop.png';

export interface IProductMadnessPlayerLevelProps {
  playerLevelImage?: string;
}

export const ProductMadnessPlayerLevel: React.FC<
  IProductMadnessPlayerLevelProps
> = ({ playerLevelImage }) => {
  const { storeTheme } = useStoreState();

  const { bundlesInternalViewModel } = storeTheme!.general;

  const mapProductMadnessProps: Partial<
    Record<EBundlesInternalViewModel, Object>
  > = useMemo(
    () => ({
      [EBundlesInternalViewModel.JACKPOT_SLOTS]: {
        desktopLogoImage: jackpotSlotsDesktopLogo,
        backgroundImage: jackpotSlotsBackgroundImage,
      },
      [EBundlesInternalViewModel.BIG_FISH_CASINO]: {
        desktopLogoImage: bigFishDesktopLogo,
        backgroundImage: bigFishBackgroundImage,
      },
    }),
    [],
  );

  return (
    <ProductMadnessValueBlock
      {...mapProductMadnessProps[bundlesInternalViewModel]}
      mobileLogoImage={storeTheme!.general.logo}
      playerLevelImage={playerLevelImage}
      storeSaleImage={storeTheme!.general?.storeSaleImage}
    />
  );
};
